import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

function EcommerceDisclaimer(props) {
  const { alternateFormat, verbiage } = props;
  if (!verbiage) {
    return null;
  }

  const html = {
    __html: verbiage,
  };

  let modifierClassName;
  if (alternateFormat) {
    modifierClassName = 'ecommerce-disclaimer--alternate';
  }

  return (
    <section data-test="ecommerce-disclaimer" className={classNames('ecommerce-disclaimer', modifierClassName)}>
      <p
        data-test="ecommerce-disclaimer__content"
        className="ecommerce-disclaimer__content"
        dangerouslySetInnerHTML={html} // eslint-disable-line react/no-danger
      />
    </section>
  );
}

EcommerceDisclaimer.propTypes = {
  verbiage: PropTypes.string,
  alternateFormat: PropTypes.bool,
};

EcommerceDisclaimer.defaultProps = {
  verbiage: '',
  alternateFormat: false,
};

export default EcommerceDisclaimer;
